.wrapper {
  font-family: var(--ns-font-family);
  font-size: var(--ns-font-size-4);
  min-height: var(--ns-min-height-content);
  display: block;
  padding: 0;
  margin: 0 auto;
}

@media (max-width: 767px) {
  .wrapper[data-nosto-element="category"] {
    /* padding: 0 0.75rem; */
  }

  .wrapper[data-nosto-element="search"] {
    /* margin: 0 -0.75rem; */
  }
}

@media (min-width: 768px) {
  .wrapper[data-nosto-element="category"] {
    max-width: 1311px;
  }

  .wrapper[data-nosto-element="search"] {
    margin: 0 -1.5rem;
  }
}

.container {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 0;
}

.loading {
  position: relative;
}

/* Remove border-bottom from .subcategory-item only on its last row (2/row mobile, 4/row desktop),
   regardless of how many items end up in that row. */
@media (max-width: 767px) {
  :global(.subcategory-item:nth-child(2n+1):nth-last-child(-n+2)),
  :global(.subcategory-item:nth-child(2n+1):nth-last-child(-n+2) ~ .subcategory-item) {
    border-bottom: none !important;
  }
}

@media (min-width: 768px) {
  :global(.subcategory-item:nth-child(4n+1):nth-last-child(-n+4)),
  :global(.subcategory-item:nth-child(4n+1):nth-last-child(-n+4) ~ .subcategory-item) {
    border-bottom: none !important;
  }
}
